import React from "react";

// Material-UI Components
import Badge from "@material-ui/core/Badge";

// React Router
import { useHistory } from "react-router-dom";

// Local Assets
import moreFilter from "../../../../assets/icons/filter.svg";

// Custom Components
import GenericTable from "../../../GenericTable/GenericTable";
import RequestAdvanceFilter from "../../Popover/RequestAdvanceFilter";

// Local Stylesheet
import "./RequestTable.scss";

function RequestTable({
  isLoading = false,
  table,
  pageIndex = 0,
  globalFilter,
  setGlobalFilter,
  isAdvanceFilterOpen = false,
  openAdvanceFiler,
  handleCloseForAdvanceFilter,
  handleFilterChange,
  advanceFilterState,
  anchorElForAdvanceFilter,
  isAdvanceFilterActive,
  setPageIndex,
}) {
  const history = useHistory();
  const id = isAdvanceFilterOpen ? "simple-popover" : undefined;

  return (
    <div className="request-table-container-wrapper">
      <div className="request-table-wrapper">
        <div className="d-flex">
          <div className="search-box">
            <input
              type="text"
              maxLength="50"
              placeholder="&#xF002;  Search Requests"
              className="search-placeholder set-width"
              value={globalFilter}
              onChange={(e) => {
                setGlobalFilter(e.target.value);
                setPageIndex(0);
              }}
            />
          </div>
          <Badge
            color="secondary"
            variant={isAdvanceFilterActive ? "dot" : undefined}
          >
            <img
              src={moreFilter}
              alt="moreFilter"
              className="ml-4 cursor-pointer more-filter-icon"
              onClick={openAdvanceFiler}
            />
          </Badge>
          <RequestAdvanceFilter
            id={id}
            open={isAdvanceFilterOpen}
            anchorEl={anchorElForAdvanceFilter}
            onClose={handleCloseForAdvanceFilter}
            state={advanceFilterState}
            handleChange={handleFilterChange}
          />
        </div>
        <div>
          <GenericTable
            table={table}
            tableClassName="request-table-container"
            rowOnClickHandler={(rowData) => {
              history.push(`requests/${rowData.original.id}`);
            }}
            shouldEnablePagination
            pageIndex={pageIndex}
            isLoading={isLoading}
            noRecordFoundMsg={"No request found."}
            setPageIndex={setPageIndex}
          />
        </div>
      </div>
    </div>
  );
}

export default RequestTable;
